const NATIONAL_QUESTION_IDS = new Set([13, 14, 15]);

function normalizeQuestionId(perguntaId) {
  if (perguntaId === undefined || perguntaId === null) {
    return null;
  }

  const numericId = Number(perguntaId);
  if (Number.isNaN(numericId)) {
    return null;
  }

  return numericId;
}

export function isNationalCriterion(perguntaId) {
  const normalizedId = normalizeQuestionId(perguntaId);
  if (normalizedId === null) {
    return false;
  }

  return NATIONAL_QUESTION_IDS.has(normalizedId);
}

export function shouldTreatAsNational(perguntaId, ehPerguntaClienteOculto) {
  if (ehPerguntaClienteOculto === true || ehPerguntaClienteOculto === 1) {
    return true;
  }

  if (ehPerguntaClienteOculto === false || ehPerguntaClienteOculto === 0) {
    return isNationalCriterion(perguntaId);
  }

  if (typeof ehPerguntaClienteOculto === "string") {
    const normalized = ehPerguntaClienteOculto.trim().toLowerCase();
    if (["1", "true", "sim", "yes"].includes(normalized)) {
      return true;
    }

    if (["0", "false", "nao", "não", "no"].includes(normalized)) {
      return isNationalCriterion(perguntaId);
    }
  }

  if (ehPerguntaClienteOculto) {
    return true;
  }

  return isNationalCriterion(perguntaId);
}

export default {
  isNationalCriterion,
  shouldTreatAsNational,
};
